export const BETA_COOKIE = 'beta';
export const ANALYTICS_V2_ENABLED_COOKIE = 'analyticsV2Enabled';
